import * as React from 'react';
import type { SVGProps } from 'react';

const SvgMn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path
      fillRule="evenodd"
      d="m290.73 3.102 26.414 21.152 37.672-21.152 54.191 63.383h43.176l69.09 21.512 23.707 26.297 52.324-26.297 94.828 19.89 50.551 59.923 39.129-16.773 59.746 41.539 17.691 34.469 106.99-52.61 25.48 31.407h94.188l86.645 21.203-86.645 47.516-94.188 30.699-73.711 80.07-156.01 138.42-6.602 133.44-63.266 34.074-21.102 65.973 30.473 39.727-22.57 75.539 13.2 77.46 105.33 67.38 24.28 45.574 73.887 49.84 15.781 83.426H136.9v-375.68L94.872 796.96l-17.055-46.363 36.996-34.57-6.597-116.39-30.398-69.266 10.457-59.465-17.07-144.29-44.758-134.04v-84.688l6.601-34.777-6.601-70.008z"
    />
  </svg>
);
export default SvgMn;
